export default {
    cz: {
        yes: 'ano',
        activity: 'aktivita',
        social: 'sociální',
        communication: 'komunikační',
        cognitive: 'kognitivní',
        emotional: 'emoční',
        motoric: 'pohybové',
        sensoric: 'smyslové',
        area: 'oblast',
        skills: 'dovednosti',
        age: 'věk',
        year: {
            0: 'let',
            1: 'rok',
            2: 'let',
            3: 'let',
            4: 'let',
            5: 'let',
        },
        old: 'starý',
        disability: 'postižení',
        sight: 'zrak',
        hearing: 'sluch',
        sightIcon: 'děti se zrakovým postižením',
        hearingIcon: 'děti se sluchovým postižením',
        ageIcon: 'děti staré',
        to: 'až',
        individualIcon: 'individuální aktivita',
        groupIcon: 'skupinová aktivita',
        select: 'vyberte',
        development: 'vývoj',
        description: 'popis',
        instructions: 'instrukce',
        notes: 'poznámky',
        afterActivityQuestions: 'otázky pro reflexi',
        expand: 'rozbalit',
        collapse: 'sbalit',
        screening_continue_summary: 'Závěrečné hodnocení',
        screening_back_to_start: 'Zpět na začátek screeningu',
        back_to: 'Zpět',
        continue: 'Pokračovat',
        activities_attachment: 'přílohy',
        activities_group: 'Skupinové aktivity',
        activities_individual: 'Individuální aktivity',
        activities_all: 'Všechny aktivity',
        areas_mainTitle: 'Výběr oblasti rozvoje dítěte',
        areas_competence: `dovednosti`,
        areas_activities: `aktivity`,
        areas_screening: 'skrýning',
        areas_methodicalClarification: 'metodická klarifikace',
        mainGoals: 'Hlavní cíle',
        intended: 'Pro koho je aktivita určená',
        run: 'spustit aktivitu',
        workbook: 'pracovní sešit',
        recordSheet: 'záznamový hárok',
        mainImage: 'hlavní obrázek',
        areas_goodPracticeExamples: 'ukázky dobré praxe',
        areas_areaDetail: `Rozvoj {area} dovednosti`,
        header_home: 'Úvod',
        header_areas: 'Oblasti',
        header_activities: 'Aktivity',
        header_manual: 'Teórie',
        header_initialScreening: 'Úvodní screening',
        header_search: 'hledat',
        screeningPrint_activityDevelopment: 'Rozvoj podoblastí',
        screeningPrint_success: 'Úspěch',
        screeningPrint_withHelp: 'S dopomocí',
        screeningPrint_failed: 'Řešeno neúspěšně',
        screeningPrint_activityName: 'Název aktivity',
        screeningPrint_description: 'Prosím, zapište datum do sloupců',
        screeningPrint_title: 'Aktivita byla vykonána',
        screeningPrint_text: 'Doporučené aktivity pro rozvoj {area} dovedností',
        screeningPrint_area: '{area}ch',
        screeningPrint_finalValuation: 'závěrečné hodnocení',
        initialScreening_enterName: 'zadajte jméno dítěte',
        initialScreening_screeningStart: 'provést screening',
        initialScreening_screeningFinished: 'screening ukončen',
        initialScreening_childInfo: 'informace o dítěti',
        initialScreening_highRating: 'zvládá samostatně / běžně se projevuje',
        initialScreening_secondRating:
            've většině běžných situací zvládá bez dopomoci, v některých situacích dopomoc potřebuje / většinou se projevuje.',
        initialScreening_thirdRating: 'v některých situacích zvládá bez dopomoci / někdy se projevuje',
        initialScreening_fourthRating: 'zvládá pouze s dopomocí /projevuje se výjimečně',
        initialScreening_lowRating: 'nezvládá / neprojevuje se',
        initialScreening_customValuation: 'Vaše osobní hodnocení pro tuto oblast',
        initialScreening_finalValuation: 'Napište prosím své závěrečné hodnocení',
        aboutProject: 'O Projektu',
        aboutProjectDesc:
            'Aplikace WELCOME IDEA je jedním z výstupů projektu WELCOME (WE Learn and COMmunicate Ensamble), koordinovaného Nakladatelstvím Dr. Josef Raabe s.r.o. v České republice. Jedná se o mezinárodní evropský projekt Erasmus+, spadající pod Klíčovou akci 2 (KA2, 2016-1-CZ01-KA201-024036), jehož se účastní Česká republika, Slovenská republika a Bulharsko.  Hlavním cílem projektu WELCOME je podpořit inkluzi v mateřských školách a nabídnout funkční nástroje pro práci s dětmi se speciálními vzdělávacími potřebami (SVP), jejichž rozvoj je ovlivněn znevýhodněním či postižením. Učitelům poskytneme teoretické zázemí a praktické návrhy pro systematickou podporu dětí s SVP v rámci skupinové i individuální práce.',
        projectOutputs: 'Výstupy projektu',
        projectOutputsDesc:
            'METODIKA PRO PRÁCI S DĚTMI S SVP V PŘEDŠKOLNÍM VZDĚLÁVÁNÍ Publikace je určená pedagogům mateřských škol, kteří hledají nové inspirace pro práci s heterogenní třídou z hlediska podpory vzdělávacích potřeb dětí s SVP. Metodika přináší v přehledné a ucelené formě informace a náměty pro práci s dětmi s SVP a je rozdělena na teoretickou a metodickou část. APLIKACE WELCOME IDEA (INTERAKTIVNÍ DIGITÁLNÍ EDUKATIVNÍ ASISTENT) Aplikace pro chytrá zařízení funguje jako pomyslný asistent: Učitel díky pedagogické diagnostice v aplikaci vyhodnotí aktuální stav dítěte v jednotlivých oblastech rozvoje, aplikace pak na základě výsledků pedagogické diagnostiky doporučí vybrané aktivity. Soubor aktivit umožňuje nejen interaktivní práci dětem se speciálními vzdělávacími potřebami, ale přináší i řadu dalších nápadů, jak pracovat s heterogenní skupinou dětí ve třídě a zároveň zapojit děti s SVP. PODPORA PRÁCE S DĚTMI S SVP V PŘEDŠKOLNÍM VZDĚLÁVÁNÍ (WELCOME WORKSHOPY) Jedná se o ucelený návod pro učitele, jak uspořádat a vést integrované bloky, v jejichž rámci budou realizovány různé tematické celky s využitím aplikace. Cílem je poskytnout příklady integrovaných bloků, které pomohou pedagogům používat aplikaci v praxi – důsledně realizovat individualizovaný a diferenciovaný přístup ve vzdělávání při práci s heterogenní skupinou dětí a v nejvyšší možné míře podporovat rozvoj každého dítěte, jeho aktivitu, samostatnost a kooperaci s ostatními dětmi. Návod byl v praxi testován v mateřských školách v každé projektové zemi tak, aby zcela splňoval požadavky pro vedení pracovních skupiny zahrnujících děti bez speciálních potřeb, děti s SVP i učitele.',
        projectPartners: 'Partneři projektu',
        projectPartnersDesc:
            'Pedagogická fakulta jsou Univerzity Karlovy v Praze (CZ), Výskumný ústav detskej psychológie a patopsychologie v Bratislavě (SK), Institut za psihichno zdrave i razvitie v Sofii (BG), M7 v Bratislavě (SK), MŠ a ZŠ M. Alše v Miroticích (CZ), MŠ a ZŠ Zubrohlava v Zubrohlavě (SK), MŠ Prikazka bez krai v Sofii (BG)',
    },
    en: {
        yes: 'yes',
        activity: 'activity',
        social: 'social',
        communication: 'communication',
        cognitive: 'cognitive',
        emotional: 'emotional',
        motoric: 'motoric',
        sensoric: 'sensoric',
        area: 'area',
        skills: 'skills',
        age: 'age',
        year: {
            0: 'years',
            1: 'year',
            2: 'years',
            3: 'years',
            4: 'years',
            5: 'years',
        },
        old: 'old',
        disability: 'disability',
        sight: 'sight',
        hearing: 'hearing',
        sightIcon: 'children with sight disability',
        hearingIcon: 'children with hearing disability',
        ageIcon: 'children aged',
        to: 'to',
        individualIcon: 'individual activity',
        groupIcon: 'group activity',
        select: 'select',
        development: 'development',
        description: 'description',
        instructions: 'instructions',
        notes: 'notes',
        afterActivityQuestions: 'after activity questions',
        expand: 'expand',
        collapse: 'collapse',
        screening_continue_summary: 'Continue to screening summary',
        screening_back_to_start: 'Back to screening start',
        back_to: 'Back to',
        continue: 'Continue to',
        activities_attachment: 'attachments',
        activities_group: 'Group activities',
        activities_individual: 'Individual activities',
        activities_all: 'All activities',
        areas_mainTitle: 'Choose area of development',
        areas_competence: `competence`,
        areas_activities: `activities`,
        areas_screening: 'screening',
        areas_methodicalClarification: 'methodical clarification',
        mainGoals: 'Main goals',
        intended: 'For whom it is intended',
        run: 'run activity',
        workbook: 'workbook',
        recordSheet: 'record sheet',
        mainImage: 'main image',
        areas_goodPracticeExamples: 'good practice examples',
        areas_areaDetail: 'Development of {area} competence',
        header_home: 'Home',
        header_areas: 'Areas',
        header_activities: 'Activities',
        header_manual: 'Theory',
        header_initialScreening: 'Initial screening',
        header_search: 'search',
        screeningPrint_activityDevelopment: 'Development of sub areas',
        screeningPrint_success: 'Succes',
        screeningPrint_withHelp: 'With help',
        screeningPrint_failed: 'failed',
        screeningPrint_activityName: 'Name of activity',
        screeningPrint_description: 'please write a date into this columns',
        screeningPrint_title: 'Activity was performed',
        screeningPrint_text: 'Recommended activities for development of {area} skills',
        screeningPrint_area: '{area}',
        screeningPrint_finalValuation: 'final valuation',
        initialScreening_enterName: 'enter the name of a child',
        initialScreening_screeningStart: 'start screening',
        initialScreening_screeningFinished: 'screening finished',
        initialScreening_childInfo: 'information about child',
        initialScreening_highRating: 'child is in emotional comfort',
        initialScreening_lowRating: 'unresponsive even with help',
        initialScreening_customValuation: 'Your custom valuation for this area',
        initialScreening_finalValuation: 'Please write your final valuation',
        aboutProject: 'About project',
        aboutProjectDesc:
            'This project’s aim is to help teachers and children in kindergartens. It focuses on ways of leading a heterogeneous class and offers ideas and activities for children with various skills and needs. ',
        projectOutputs: 'Project outputs',
        projectOutputsDesc:
            'There will be three project outputs you may look forward to. The WELCOME Teachers Manual, WELCOME App for smart devices and workshops for children and teachers. We will inform you on their development during the project lifetime.',
        projectPartners: 'Project partners',
        projectPartnersDesc:
            'Partners from three European countries – Czech Republic, Slovakia and Bulgaria – participate in the project. The connection of experts, academic sector and teachers ensures coherence between theory and practice.',
    },
};
